import * as React from 'react';
import { ActionButton, fetchApi, notifyError, notifyResponse } from 'gossamer-front-end';
import { useNavigate } from 'react-router-dom';
import { TaskDefinition } from 'packages/gossamer-model';

export interface WorkflowCopyButtonProps {
  taskDefId: number;
}

export const WorkflowCopyButton: React.FC<WorkflowCopyButtonProps> = (props) => {
  const navigate = useNavigate();
  return (
    <ActionButton
      label="Copy Workflow"
      size="sm"
      variant="primary"
      waiting={false}
      execute={async (resetCache) => {
        try {
          const response = await fetchApi('POST', `/main/copy-workflow/${props.taskDefId}`);
          resetCache(TaskDefinition.id);
          notifyResponse(response);
          navigate('/admin/workflow/search');
        } catch (e) {
          notifyError(e, 'An error occurred while copying the workflow');
        }
      }}
    />
  );
};
